
import { Vue, Component, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import { CSaleOrderDetail } from '@/models/supply.model';
import ImagePreviewModal from './ImagePreviewModal.vue';

@Component({
  components: {
    ImagePreviewModal,
  },
})
export default class SalesOrderDetailModal extends Vue {
  visible = false;

  loading = false;

  detail: any = {};

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  productList: any[] = [];

  paymentStatusMap: any = {
    0: '待付款',
    1: '待收款',
    2: '已收款',
  };

  orderStatusMap: any = {
    0: '待发货',
    1: '已发货',
    2: '已完成',
  };

  invoiceStatusMap: any = {
    0: '待开票',
    1: '已开票',
  };

  record: any = {};

  productColumns = [
    {
      title: '物料编号',
      dataIndex: 'commodity_code',
      align: 'center',
    },
    {
      title: '产品名称',
      dataIndex: 'commodity_name',
      align: 'center',
    },
    {
      title: '规格',
      dataIndex: 'specification',
      align: 'center',
      scopedSlots: { customRender: 'specification' },
    },
    {
      title: '数量/箱',
      dataIndex: 'quantityPerBox',
      align: 'center',
      scopedSlots: { customRender: 'quantityPerBox' },
    },
    {
      title: '下单箱数',
      dataIndex: 'package_quantity',
      align: 'center',
    },
    {
      title: '下单壶数',
      dataIndex: 'orderPots',
      align: 'center',
      scopedSlots: { customRender: 'orderPots' },
    },
    {
      title: '单价/壶',
      dataIndex: 'agent_price',
      align: 'center',
    },
    {
      title: '小计（元）',
      dataIndex: 'amount',
      align: 'center',
      scopedSlots: { customRender: 'subtotal' },
    },
  ];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  async open(record: any) {
    this.record = record || {};
    const res = await this.supplyService.getSaleOrderDetail(record.orderNo || record.order_no);
    this.detail = CSaleOrderDetail.from(res);
    this.visible = true;
    this.getDetail();
  }

  async getDetail() {
    const res = await this.supplyService.getCommodityDetailByOrder({
      order_no: this.record.orderNo || this.record.order_no,
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
    });
    this.productList = res.list;
    this.pagination.total = res.total;
  }

  // 下单壶数 = 下单箱数 * 数量/箱
  calcOrderPots(record: any) {
    const boxes = Number(record.orderBoxes) || 0;
    const perBox = Number(record.quantityPerBox) || 0;
    return boxes * perBox;
  }

  // 小计 = 单价/壶 * 下单壶数
  calcSubtotal(record: any) {
    const price = Number(record.pricePerPot) || 0;
    return (price * this.calcOrderPots(record)).toFixed(2);
  }

  viewImages(title: string, images: any[]) {
    this.imagePreviewModal.open(title, images || []);
  }


  viewDeliveryOrder(value: any) {
    const urls = value.sign_resource ? value.sign_resource.map((item: any) => item.url) : [];
    this.imagePreviewModal.open('发货单', urls || []);
  }

  @Ref('imagePreviewModal')
  imagePreviewModal!: ImagePreviewModal;

  submit() {
    // TODO: 调用提交接口，参数：this.detail、this.productList（含下单箱数/壶数/小计）
    this.$message.success('操作成功');
    this.$emit('refresh');
    this.onClose();
  }

  onClose() {
    this.visible = false;
    this.detail = {};
    this.productList = [];
    this.pagination.current = 1;
    this.pagination.total = 0;
    this.pagination.pageSize = 10;
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getDetail();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = size;
    this.getDetail();
  }
}
